export default __webpack_public_path__ + "static/media/gallery_04.41d4944e.jpg";